import React from "react";
import { hideDiscountInfo } from "../../../../../../common-deprecated/priceUtils";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import type { PriceConfigType, PriceType } from "../../../../../../common-deprecated/types/CommonTypes";
import * as ContentStyles from "../styles/EquipmentContent";
import {
    formatAEMCashPrice,
    hasDualCurrency,
} from "../../../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { useEquipmentV2Selector } from "../../../redux/store";

type CashPriceType = { price: PriceType; priceConfig: PriceConfigType; cultureName: string };

const CashPrice = (props: CashPriceType): JSX.Element => {
    const { price, priceConfig, cultureName } = props;

    const hasSecondaryPrice = useEquipmentV2Selector((state) => hasDualCurrency(state.commonSettings));

    const formattedPrimaryPrice = formatAEMCashPrice(price.discount, cultureName, priceConfig);
    const formattedSecondaryPrice = formatAEMCashPrice(price.discount, cultureName, priceConfig, undefined, true);

    const isDiscounted = !hideDiscountInfo(priceConfig) && price.cash !== price.discount;

    return (
        <div>
            <ContentStyles.PriceWrapper>
                <Type.Strong role="heading" aria-level={4}>
                    <span dangerouslySetInnerHTML={{ __html: formattedPrimaryPrice }} />
                </Type.Strong>
                {/* Dual currency price */}
                {hasSecondaryPrice && (
                    <Type.Strong role="heading" aria-level={5}>
                        <span dangerouslySetInnerHTML={{ __html: formattedSecondaryPrice }} />
                    </Type.Strong>
                )}
            </ContentStyles.PriceWrapper>
            {isDiscounted && (
                <ContentStyles.Item
                    dangerouslySetInnerHTML={{ __html: formatAEMCashPrice(price.cash, cultureName, priceConfig) }}
                />
            )}
        </div>
    );
};

export default CashPrice;
